// extracted by mini-css-extract-plugin
module.exports = {"container":"CompanyOnboarding_container__1VT-a","illustrationCol":"CompanyOnboarding_illustrationCol__2WsHx","illustration":"CompanyOnboarding_illustration__2m0Om"};